"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaDataAudioParamsToJSON = exports.CaptchaDataAudioParamsFromJSONTyped = exports.CaptchaDataAudioParamsFromJSON = void 0;
function CaptchaDataAudioParamsFromJSON(json) {
    return CaptchaDataAudioParamsFromJSONTyped(json, false);
}
exports.CaptchaDataAudioParamsFromJSON = CaptchaDataAudioParamsFromJSON;
function CaptchaDataAudioParamsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'movie': json['movie'],
    };
}
exports.CaptchaDataAudioParamsFromJSONTyped = CaptchaDataAudioParamsFromJSONTyped;
function CaptchaDataAudioParamsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'movie': value.movie,
    };
}
exports.CaptchaDataAudioParamsToJSON = CaptchaDataAudioParamsToJSON;
//# sourceMappingURL=CaptchaDataAudioParams.js.map